import { createFileRoute } from '@tanstack/react-router';
import { BannerEditor } from '@/components/marketing/BannerEditor';

export const Route = createFileRoute('/_admin/banners')({
  component: BannersPage,
});

function BannersPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Banners</h1>
        <p className="text-muted-foreground">
          Arraste para reordenar • Gerencie a exibição dos banners no site
        </p>
      </div>

      <BannerEditor />
    </div>
  );
}
